import React, { useState } from "react";
import Icon, { IconName } from "../icon";
import ToolbarSubscriptionRequiredLink from "./toolbar-subscription-required-link";
import SiteOverlay from "../site-overlay";
import { useAnalytics } from "../../hooks/use-ga";
var ArticleToolbar = function ArticleToolbar(_ref) {
    var onBookmarkClicked = _ref.onBookmarkClicked, bookmarked = _ref.bookmarked, pdfStatus = _ref.pdfStatus, audioStatus = _ref.audioStatus, openModal = _ref.openModal, withSpotlight = _ref.withSpotlight, className = _ref.className, article = _ref.article, slug = _ref.slug;
    var _useState = useState(false), overlayStatus = _useState[0], setOverlayStatus = _useState[1];
    var joinAuthors = function joinAuthors(authorsArray) {
        if (authorsArray.length > 1) {
            var lastAuthor = authorsArray.slice(-1)[0];
            return authorsArray.slice(0, -1).join(", ") + " and " + lastAuthor + "}";
        }
        return authorsArray.join("");
    };
    var baseURL = "https://makroskop.eu";
    var linkToShare = baseURL + "/" + slug + "/";
    var mailTitle = article.title + " auf MAKROSKOP";
    var mailBody = "Interessanter Artikel auf MAKROSKOP:\n" + article.title + "\nvon " + joinAuthors(article.authors.map(function (a) {
        return a.name;
    })) + "\n" + linkToShare;
    var mailLink = "mailto:?subject=" + encodeURI(mailTitle) + "&body=" + encodeURI(mailBody);
    var twitterLink = "https://twitter.com/intent/tweet?url=" + linkToShare;
    var whatsappLink = "https://api.whatsapp.com/send?text=" + encodeURI(mailBody);
    var onOverlayClose = function onOverlayClose() {
        return setOverlayStatus(false);
    };
    var onFacebookIconClick = function onFacebookIconClick() {
        // @ts-ignore
        window.FB.ui({
            display: "popup",
            method: "share",
            href: linkToShare
        });
    };
    var trackRedirection = function trackRedirection(articleId) {
        var _useAnalytics = useAnalytics(), trackReadAlso = _useAnalytics.trackReadAlso;
        trackReadAlso(articleId);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "mt-4 mb-3 lg:mt-6 lg:mb-8 lg:justify-end " + className
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex flex-wrap justify-end lg:block"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: onBookmarkClicked,
        className: "block mr-2 lg:mr-0"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.BOOKMARK,
        color: bookmarked ? withSpotlight ? "#FF0015" : "#0066ba" : withSpotlight ? "#005C16" : "#ff5b00",
        className: "w-8 mb-2",
        tooltip: "Lesezeichen setzen"
    })), /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            return setOverlayStatus(true);
        },
        className: "mr-2 lg:mr-0"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.SHARE,
        color: withSpotlight ? "#005C16" : "#ff5b00",
        className: "w-8 mb-0",
        tooltip: "Diesen Artikel teilen"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "mr-2 lg:mr-0"
    }, /*#__PURE__*/ React.createElement(ToolbarSubscriptionRequiredLink, {
        openModal: openModal,
        status: audioStatus,
        iconName: IconName.AUDIO,
        title: "Audio herunterladen",
        withSpotlight: withSpotlight
    })), /*#__PURE__*/ React.createElement(ToolbarSubscriptionRequiredLink, {
        openModal: openModal,
        status: pdfStatus,
        iconName: IconName.PDF,
        title: "PDF herunterladen",
        withSpotlight: withSpotlight
    })), /*#__PURE__*/ React.createElement(SiteOverlay, {
        onClose: onOverlayClose,
        open: overlayStatus
    }, /*#__PURE__*/ React.createElement("div", {
        className: "m-auto max-w-xs"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "bg-white p-4 pb-0 rounded-sm mx-4"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "text-lg font-medium mb-4 border-b-4 border-solid " + (withSpotlight ? "border-makroGreen" : "border-makroOrange")
    }, "Diesen Artikel teilen:"), /*#__PURE__*/ React.createElement("ul", {
        className: "flex flex-wrap"
    }, /*#__PURE__*/ React.createElement("li", {
        className: "w-1/2 mb-4 pr-2 flex-shrink-0 cursor-pointer",
        onClick: function onClick() {
            return trackRedirection("mail");
        }
    }, /*#__PURE__*/ React.createElement("a", {
        href: mailLink,
        target: "_blank",
        className: "flex items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.EMAIL,
        color: "#555555",
        className: "w-8 mr-2"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text-base font-medium"
    }, "E-Mail"))), /*#__PURE__*/ React.createElement("li", {
        className: "w-1/2 mb-4 pr-2 flex-shrink-0 cursor-pointer"
    }, /*#__PURE__*/ React.createElement("button", {
        onClick: function onClick() {
            onFacebookIconClick();
            trackRedirection("facebook");
        },
        className: "flex items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.FACEBOOK,
        color: "#3b5998",
        className: "w-8 mr-2"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text-base font-medium"
    }, "Facebook"))), /*#__PURE__*/ React.createElement("li", {
        className: "w-1/2 mb-4 pr-2 flex-shrink-0 cursor-pointer",
        onClick: function onClick() {
            return trackRedirection("twitter");
        }
    }, /*#__PURE__*/ React.createElement("a", {
        href: twitterLink,
        target: "_blank",
        className: "flex items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.TWITTER,
        color: "#00acee",
        className: "w-8 mr-2"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text-base font-medium"
    }, "Twitter"))), /*#__PURE__*/ React.createElement("li", {
        className: "w-1/2 mb-4 pr-2 flex-shrink-0 cursor-pointer",
        onClick: function onClick() {
            return trackRedirection("whatsapp");
        }
    }, /*#__PURE__*/ React.createElement("a", {
        href: whatsappLink,
        target: "_blank",
        className: "flex items-center"
    }, /*#__PURE__*/ React.createElement(Icon, {
        iconName: IconName.WHATSAPP,
        color: "#075e54",
        className: "w-8 mr-2"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "text-base font-medium"
    }, "WhatsApp"))))))));
};
export default ArticleToolbar;
